module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/cpu-2-b988a8375f209a7a8b48f690b069928e.svg";